import { footerSections, siteName, hotSearchWords } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 font-heading text-lg font-black text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-black tracking-tight">{siteName}</span>
            </div>
            <p className="mt-4 max-w-sm font-label text-sm leading-relaxed text-background-200/90">
              把圈内热帖、爆料与后续进度按索引收在一起，方便你顺着时间线围观，也方便回头查已经看过的细节。
            </p>
            <div className="mt-5 flex flex-wrap gap-1.5">
              {hotSearchWords.slice(0, 5).map((word) => (
                <span
                  key={word}
                  className="whitespace-nowrap rounded-full bg-primary-800/80 px-2.5 py-1 font-label text-xs text-background-200"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {section.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {section.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#latest"
                      className="whitespace-nowrap font-label text-sm text-background-200/85 transition-colors hover:text-accent-300 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg border border-primary-700/70 bg-primary-950/40 p-4 md:p-5">
          <div className="flex items-start gap-3">
            <i className="ri-information-line mt-0.5 text-lg text-accent-300"></i>
            <p className="font-label text-xs leading-relaxed text-background-200/85">
              本站内容为网友投稿与公开信息整理，仅作围观讨论与索引存档之用，不对其中观点与指向作任何背书；如涉及疏漏或错误，可在「纠错反馈」提交，我们会随时更新。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-4 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-300/80">
            © 2026 {siteName}网 · 内容索引社区 · 热帖爆料一网看尽
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#track" className="whitespace-nowrap font-label text-xs text-background-300/80 hover:text-accent-300 cursor-pointer">
              进度公告
            </a>
            <a href="#collection" className="whitespace-nowrap font-label text-xs text-background-300/80 hover:text-accent-300 cursor-pointer">
              合集总览
            </a>
            <a href="#buzz" className="whitespace-nowrap font-label text-xs text-background-300/80 hover:text-accent-300 cursor-pointer">
              讨论规范
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}